<template>
  <div class="all-wrap">
    <div class="tabs">
      <div class="tab-item-active myAsk" @click="changeTab('getWordSub')">课程&电子书</div>
    </div>
    <div class="course-list" v-if="dataList&&dataList.length">
        <dl v-for="(data,index) in dataList" :key="data.id" :class="index%4===0?'course-margin':''">
            <dt>
                <img :src="data.url" @click="handleDetail(data.goodsId,data.itemCategories)"/>
            </dt>
            <dd>
                <p class="course-con overell" @click="handleDetail(data.goodsId,data.itemCategories)">{{data.goodsName}}</p>
                <p class="course-expire">还剩{{data.loseTime}}天过期</p>
            </dd>
        </dl>
    </div>
    <div v-else>
      <div style="text-align:center">
        <img src="@/assets/img/good/noGood.png" alt="暂无数据">
      </div>
    </div>
    <!-- <div class="page">
       <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
      style="margin:0 69px;"
    ></el-pagination>
        </div> -->
        <!-- 分页 -->
    <el-pagination background
      style="margin-top:10px;text-align: center;"
      layout="prev, pager, next, total, jumper, slot"
      prev-text="上一页"
      next-text="下一页"
      @size-change="handleSizeChange"
      @current-change="getCourseList"
      :current-page="currentPage" :page-size="10" :pager-count="5"
       :total="total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1
    }
  },
  mounted () {
    this.getCourseList()
  },
  methods: {
    handleSizeChange (val) {
      this.getCourseList(1)
    },
    // handleCurrentChange (val) {
    //   this.currentPage = val
    //   this.getCourseList()
    // },
    getCourseList (page = this.currentPage) {
      this.currentPage = page
      this.$http.post(`/front/train/trainUserBuy/userCenterCourseBook`,
        {
          'page': this.currentPage,
          'limit': 10,
          'id': this.$store.state.user.userId
        })
        .then(data => {
          // console.log(data)
          this.dataList = data.data.data.data
          // this.totalPage = data.data.data.count
          // 分页
          this.total = data.data.data.count
          this.changePageTo(this.currentPage)
          // console.log(this.totalPage)
          // if (this.totalPage >= 5) {
          //   this.pageList = [1, 2, 3, 4, 5];
          //   this.lastOmit = "";
          //   this.nextOmit = "...";
          // } else {
          //   var newPage = [];
          //   for (let i = 1; i <= this.totalPage; i++) {
          //     newPage.push(i);
          //   }
          //   this.pageList = newPage;
          //   this.lastOmit = "";
          //   this.nextOmit = "";
          // }
        })
      this.jumpTargetPage = 1
    },
    // 跳转课程明细
    handleDetail (id, cat) {
      // console.log(id)
      if (cat === 1) {
        this.$router.push(
          { name: 'courseDetail', query: { id: id } })
      } else {
        this.$router.push(
          { name: 'bookinfo', query: { id: id } })
      }
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.getCourseList(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.getCourseList(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      // window.scrollTo(0, 0);
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      // this.getCourseList()
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getCourseList()
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getCourseList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getCourseList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
<style scoped>
.myAsk{
    width:100px;
    text-align: center;
}
.course-list{
    margin: 0 69px;
    height:auto;
    border-bottom:1px solid #ccc;
    margin-bottom:10px;
}
.course-list dl{
    width:180px;
    height:180px;
    margin-left:35px;
    float:left;
}
.course-list::after{
  content:"";
  clear:both;
  display:block;
  height:0;
  overflow:hidden;
  visibility:hidden;
}
.course-list dl.course-margin{
    margin-left:0
}
.course-list dl dt{
    width:100%;
    height:100px;
}
.course-list dl dt img{
    width:100%;
    height:100px;
    cursor: pointer;
}
.course-list dl dd{
    width:100%;
    height:80px;
}
.course-con{
    margin-top:10px;
    color:#333;
    cursor: pointer;
}
.course-expire{
    margin-top:10px;
    color:#f00
}
</style>
